import constants from "../../../core/constants";
import isNil from "lodash/fp/isNil";

class Controller {
  constructor($mdDialog, Events, InvoiceItem, systemCategories) {
    this.$mdDialog = $mdDialog;
    this.Events = Events;
    this.InvoiceItem = InvoiceItem;
    this.systemCategories = systemCategories;
    this.selectedCategory = undefined;
    this.confirmEvent = this.Events.getUpdateEvent("confirmAdjustment");
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;

    this.zendeskPattern = "^\\w+$";
    this.errors = {};

    this.adjustment = {};
    this.adjustmentRequirements = {
      category: "manual_adjustment",
      tags: [],
      active: true,
      isCityRequired: false,
    };
  }

  $onInit() {
    this.Events.on(this.confirmEvent, this.confirm.bind(this));
  }

  getTypes() {
    if (this.isModalValid()) {
      this.InvoiceItem.getTypes(this.adjustmentRequirements).$promise.then(
        (response) => {
          this.availableTypes = response.hits;
        },
        (err) =>
          this.Events.emit(this.errorNotificationEvent, {
            message: err.data.message,
          })
      );
    }
  }

  isModalValid() {
    return this.adjustmentRequirements.tags.length === 2;
  }

  confirm(adjustment) {
    const type = adjustment.type.key;
    const fields = adjustment[type];
    if (!isNil(fields.amount)) {
      fields.amount *= constants.currencyBy;
    }
    if (!isNil(this.selectedCategory)) {
      fields.category_id = this.selectedCategory.id;
    }
    this.$mdDialog.hide({ type, ...fields });
  }

  close() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/invoice/adjustmentDialog/adjustmentDialog.controller.js